'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Vector = require('../../utils/Vector2');

var _Vector2 = _interopRequireDefault(_Vector);

var _Confetti = require('./Confetti');

var _Confetti2 = _interopRequireDefault(_Confetti);

var _Snow = require('./Snow');

var _Snow2 = _interopRequireDefault(_Snow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styles = {
  'particleEffect': 'ccl-856824b11f86e847',
  'snowEffect': 'ccl-3fc6c29ef2764b3b'
};


var EFFECT_TYPES = ['confetti', 'snow'];
var FRAME_RATE = 60;
var CONFETTI_COLORS = [['#44adea', '#13579a'], // blues
['#ff8100', '#ffe500'], // pumpkin / lemon-cheesecake
['#ff3d3d', '#ffad93'], // beetroot / burger-sauce
['#006d68', '#b5ea44']];
var SNOW_COLORS = ['#ffffff', '#f4ffff', // white
'#f6feff', // white2
'#e6f2ff', '#cce5ff', // bluelight
'#e6f7ff', '#ccefff', // blue2light
'#e6fffc', '#e6fffc'];

/**
 * Creates an animated particle effect using `<canvas>`
 */

var ParticleEffect = function (_React$Component) {
  _inherits(ParticleEffect, _React$Component);

  function ParticleEffect(props) {
    _classCallCheck(this, ParticleEffect);

    var _this = _possibleConstructorReturn(this, (ParticleEffect.__proto__ || Object.getPrototypeOf(ParticleEffect)).call(this, props));

    _this.resize = _this.resize.bind(_this);
    _this.start = _this.start.bind(_this);
    _this.stop = _this.stop.bind(_this);
    _this.update = _this.update.bind(_this);

    _this.particles = []; // state isn’t fast/reliable enough to work with requestAnimationFrame
    _this.state = {
      isDisplayed: false
    };
    return _this;
  }

  _createClass(ParticleEffect, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (typeof window.requestAnimationFrame === 'function') {
        this.setState({ isDisplayed: true }, this.initialize); // eslint-disable-line react/no-did-mount-set-state
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stop();
    }
  }, {
    key: 'initialize',
    value: function initialize() {
      var canvasParent = this.canvas.parentNode;
      var canvasWidth = canvasParent.offsetWidth;
      var canvasHeight = canvasParent.offsetHeight;
      var bounds = new _Vector2.default(canvasWidth, canvasHeight);
      var _props = this.props,
          particleDensity = _props.particleDensity,
          particleType = _props.type,
          yStartOffset = _props.yStartOffset,
          gravity = _props.gravity,
          fadeThreshold = _props.fadeThreshold;


      this.canvas.width = canvasWidth * window.devicePixelRatio;
      this.canvas.height = canvasHeight * window.devicePixelRatio;

      var particleCount = particleDensity / 50 * canvasWidth; // eslint-disable-line no-mixed-operators
      var particle = void 0;

      for (var i = 0; i < particleCount; i += 1) {
        // eslint-disable-next-line default-case
        switch (particleType) {
          case 'confetti':
            {
              var colors = CONFETTI_COLORS[Math.round(Math.random() * (CONFETTI_COLORS.length - 1))];
              particle = new _Confetti2.default(bounds, yStartOffset, gravity, colors, fadeThreshold);
              break;
            }
          case 'snow':
            {
              var color = SNOW_COLORS[Math.round(Math.random() * (SNOW_COLORS.length - 1))];
              particle = new _Snow2.default(bounds, yStartOffset, gravity, color, fadeThreshold, 7.5);
              break;
            }
        }

        this.particles.push(particle);
      }

      this.start();
      window.addEventListener('resize', this.resize);
    }
  }, {
    key: 'resize',
    value: function resize() {
      if (this.canvas) {
        var canvasParent = this.canvas.parentNode;
        var canvasWidth = canvasParent.offsetWidth;
        var canvasHeight = canvasParent.offsetHeight;
        var bounds = new _Vector2.default(canvasWidth, canvasHeight);

        this.canvas.width = canvasWidth * window.devicePixelRatio;
        this.canvas.height = canvasHeight * window.devicePixelRatio;
        this.particles.forEach(function (particle) {
          return particle.resetBounds(bounds);
        });
      }
    }
  }, {
    key: 'start',
    value: function start() {
      this.stop();
      this.update();
    }
  }, {
    key: 'stop',
    value: function stop() {
      if (window) {
        var cancelAnimationFrame = window.cancelAnimationFrame || window.cancelRequestAnimationFrame;
        cancelAnimationFrame(this.animationRequest);
        window.removeEventListener('resize', this.resize);
      }
    }
  }, {
    key: 'update',
    value: function update() {
      if (this.canvas) {
        var _props2 = this.props,
            isLooping = _props2.isLooping,
            onAnimationComplete = _props2.onAnimationComplete,
            shouldRemoveParticlesWhenNotLooping = _props2.shouldRemoveParticlesWhenNotLooping;


        var context = this.canvas.getContext('2d');
        var interval = 1 / FRAME_RATE;
        context.clearRect(0, 0, this.canvas.width, this.canvas.height);

        this.particles = this.particles.reduce(function (result, particle) {
          var isInBounds = particle.render(interval, context, isLooping, shouldRemoveParticlesWhenNotLooping);
          if (isInBounds) {
            result.push(particle);
          }
          return result;
        }, []);

        if (this.particles.length) {
          this.animationRequest = window.requestAnimationFrame(this.update);
        } else {
          if (typeof onAnimationComplete === 'function') {
            onAnimationComplete();
          }
          this.stop();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return this.state.isDisplayed && _react2.default.createElement('canvas', {
        className: this.props.type === 'snow' ? styles.snowEffect : styles.particleEffect,
        ref: function ref(canvas) {
          return _this2.canvas = canvas;
        } // eslint-disable-line no-return-assign
      });
    }
  }]);

  return ParticleEffect;
}(_react2.default.Component);

ParticleEffect.displayName = 'ParticleEffect';
exports.default = ParticleEffect;


ParticleEffect.propTypes = {
  /**
   * The type of particle effect, e.g. 'confetti'.
   */
  type: _propTypes2.default.oneOf(EFFECT_TYPES).isRequired,

  /**
   * Does the particle effect loop forever or not?
   */
  isLooping: _propTypes2.default.bool,

  /**
   * The particle density proportional to the viewport.
   */
  particleDensity: _propTypes2.default.number,

  /**
   * The rate at which particles should fall.
   */
  gravity: _propTypes2.default.number,

  /**
   * The vertical threshold at which particles should begin to fade out, where 0 is the very top of the screen and 1 is the very bottom (i.e. don’t fade out at all).
   */
  fadeThreshold: _propTypes2.default.number,

  /**
   * The vertical offset from which particles should begin falling, where 0 is no offset and 1 is the y bounds size.
   */
  yStartOffset: _propTypes2.default.number,

  /**
   * A callback handler for when the animation ends, if the animation isn’t `isLooping` and `shouldRemoveParticlesWhenNotLooping` is true.
   */
  onAnimationComplete: _propTypes2.default.func,

  /**
   * Determines whether the particles gets removed when isLooping is false and they go off the canvas.
   * The particles remain looping on the canvas but invisible,
   * so you can toggle isLooping back to true and particles fall from the top again.
   * Having this set to false can cause performance issues.
   */
  shouldRemoveParticlesWhenNotLooping: _propTypes2.default.bool
};

ParticleEffect.defaultProps = {
  isLooping: true,
  particleDensity: 10,
  gravity: 1,
  fadeThreshold: 1,
  yStartOffset: 0,
  onAnimationComplete: undefined,
  shouldRemoveParticlesWhenNotLooping: true
};